<script lang="ts">
	import type { CourseNavigation } from '$lib/types/hygraph';
	import { classes, styles } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import { createEventDispatcher } from 'svelte';
	import LessonNavigationItem from './LessonNavigationItem.svelte';

	const dispatch = createEventDispatcher();
	const { t } = getTranslate();

	export let courseNavigation: CourseNavigation | undefined;
	export let additionalClass = '';
	export let additionalStyle = '';
</script>

<div
	class={classes(additionalClass, 'border border-black overflow-y-auto relative')}
	style={styles(additionalStyle)}
>
	<div class="w-full px-4 py-6 border-b-black border-b sticky top-0 bg-white">Lessons</div>
	{#if courseNavigation?.currentCourse?.lessons}
		<div class="">
			{#each courseNavigation.currentCourse.lessons as lesson, i}
				<LessonNavigationItem
					{lesson}
					last={i === courseNavigation.currentCourse.lessons.length - 1}
					href={`/courses/${courseNavigation?.currentCourse?.slug}/${lesson?.slug}`}
					active={lesson?.slug === courseNavigation.currentLesson?.slug}
					prefix={`${i + 1}`}
				/>
			{/each}
		</div>
	{/if}
</div>
